class ExpandedHeader extends HTMLElement {
  connectedCallback() {
    this.header = document.querySelector('.site-header');
    this.isHomepage = !!document.querySelector('.main-index');
    this.homepageScroller = document.querySelector('.main-index');
    this.changeColor = this.changeColor.bind(this);
    this.checkCurrentPanel = this.checkCurrentPanel.bind(this);
    this.panels = document.querySelectorAll('.panel');
    this.ticking = false;

    if (this.isHomepage) {
      this.homepageScroller.addEventListener('scroll', () => this.requestTick());
      document.addEventListener('scroll', () => this.requestTick());
      document.addEventListener('DOMContentLoaded', this.checkCurrentPanel);
      window.addEventListener('resize', this.checkCurrentPanel);
    }
  }

  changeColor(color) {
    if (color === 'text-white') {
      this.classList.add('text-white');
      this.classList.remove('text-black');
    } else {
      this.classList.add('text-black');
      this.classList.remove('text-white');
    }
  }

  checkCurrentPanel() {
    let scrollTop = window.scrollY || document.documentElement.scrollTop;

    if (window.matchMedia('(min-width: 959px)').matches) {
      scrollTop = this.homepageScroller.scrollTop;
    }

    for (let panel of this.panels) {
      const rect = panel.getBoundingClientRect();
      const headerHeight = parseInt(getComputedStyle(document.documentElement).getPropertyValue('--header-height'));
      const panelTop = rect.top + scrollTop - headerHeight;
      if (scrollTop >= panelTop && scrollTop < panelTop + panel.offsetHeight) {
        let newColour = panel.dataset.headerColor === 'white' ? 'text-white' : 'text-black';
        const isDesktop = window.matchMedia('(min-width: 768px)');
        if (!isDesktop.matches) {
          panel.querySelectorAll('[data-header-color-m]').forEach((x) => {
            const tileTop = x.getBoundingClientRect().top + scrollTop - headerHeight;
            if (scrollTop >= tileTop && scrollTop < tileTop + x.offsetHeight) {
              newColour = x.dataset.headerColorM === 'white' ? 'text-white' : 'text-black';
            }
          });
        }
        this.changeColor(newColour);
        break;
      }
    }

    this.ticking = false;
  }

  requestTick() {
    if (!this.ticking) {
      requestAnimationFrame(this.checkCurrentPanel);
      this.ticking = true;
    }
  }
}

customElements.define('expanded-header', ExpandedHeader);
